export const REFERRAL_SEND_FAILED = "We couldn't send the invitations. You can try again, or click Skip. Your submission will still go through."

/**
 * STY-730: a failed send used to be swallowed with the button left disabled
 * (isSubmitting never reset), so the modal hung and the vendor could not
 * submit. Now the error is shown, the button re-enables, and Skip still
 * submits.
 */
export function sendReferrals ({ post, onSent, onClose, setError, setSubmitting }) {
  setError(null)
  return Promise.resolve()
    .then(() => post())
    .then(() => {
      onSent()
      onClose()
      return true
    })
    .catch(() => {
      setError(REFERRAL_SEND_FAILED)
      setSubmitting(false)
      return false
    })
}
